import React from 'react'
import '../App.css'
import Bodyloginsa from './bodyloginsa'
export class Bodyapploginsabody extends React.Component {
    state = {
    }
    render() {       
        return (
            <div className='sshbodyapp'>
                <div className='sshbodyappContainer'>
                    <Bodyloginsa 
                        setStateApiKeyP={this.props.setStateApiKeyP} 
                        setStateMailP={this.props.setStateMailP}
                        setStateAuthCodeP={this.props.setStateAuthCodeP}/>
                </div>
            </div>
        );
    }
}